module.exports = __webpack_public_path__ + "img/transport_paavirkning_vannuttak_hymo.5242ae49.jpg";